import React, { useState, memo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { ReactHeight } from "react-height";

const styles = (theme) => ({
  root: {
    width: "100%",
    overflow: "hidden",
    position: "relative",
    height: (props) => `${props.childHeight}px`
  },
  child: {
    position: "absolute",
    display: "table",
    top: (props) => `${props.childHeight + 150}px`,
    transition: (props) => `all ${props.duration} cubic-bezier(0,0.4,0.4,1)`
  },
  visible: {
    top: "0 !important"
  }
});

const useStyles = makeStyles(styles);

function SlideUpHOC({ children, duration, when, rootClass }) {
  const [childHeight, setChildHeight] = useState(0);
  const props = { duration, childHeight };
  const classes = useStyles(props);
  return (
    <div className={clsx(classes.root, rootClass)}>
      <ReactHeight
        onHeightReady={(height) => setChildHeight(height)}
        className={clsx(classes.child, when && classes.visible)}
      >
        {children}
      </ReactHeight>
    </div>
  );
}

export default memo(SlideUpHOC);
